import { BrowserRouter, Routes } from "react-router-dom";
import "./App.css";
import Navbar from "./Components/navbar";
import HomePage from './Components/homePage';
import { createContext,useEffect, useRef, useState } from "react";
import Skills from "./Components/Skills";
import Projects from "./Components/Projects";
import Contact from "./Components/Contact";


export const Theme=createContext()

function App() {


  const [theme,setTheme]=useState('light')
  const appRef=useRef(null);




  return (
    
    <BrowserRouter>
    <Theme.Provider value={{theme, setTheme}}>
    
      <div className={`App App-${theme}`} ref={appRef}>

        <Navbar appRef={appRef} />
        <HomePage/>
        <Skills/>
        <Projects/>
        <Contact/>
        <Routes></Routes>
      </div>
      </Theme.Provider>
    
    </BrowserRouter>
  );
}

export default App;
